import script from "./DesktopLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopLayout.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopLayout.vue?vue&type=style&index=0&id=24b6112a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b6112a"]])

export default __exports__